import { useExternalParams } from 'shared/hooks';

const WORKFORCE_LIST_PARAMS = {
  search: {
    initialValue: undefined,
    type: 'string',
  },
} as const;

export const useWorkforceListParams = () => {
  const [params, setParams] = useExternalParams(WORKFORCE_LIST_PARAMS);
  const search = params.search?.trim() || undefined;

  const setSearch = (nextSearch: string) => {
    const normalizedSearch = nextSearch.trim();
    setParams({ search: normalizedSearch.length > 0 ? normalizedSearch : undefined });
  };

  const queryParams = search ? { search } : undefined;

  return { search, setSearch, queryParams };
};
